import React, { useState } from 'react'
import {
  Card,
  Table,
  Select,
  Collapse,
  Form,
  message,
  Spin,
  Radio,
  AutoComplete,
  Input,
  Modal,
  Row,
  Col,
  Button,
  Divider,
  Tabs
} from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import { loadDashboardSearchData } from '../../appRedux/actions/Reports'
import { getDecryptID } from '../../appRedux/actions'
import { Period } from '../../constants/Period'
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const viewByOptions = [
  { label: 'Day', value: Period.Day.toString() },
  { label: 'Week', value: Period.Week.toString() },
  { label: 'Month', value: Period.Month.toString() }
]
const FilterSection = () => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  //#region UseSelector
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )
  const getReduxDashboardSearchData = useSelector(
    ({ Reports }) => Reports.dashboardSearchData
  )

  //#endregion UseSelector

  const onFinish = value => {
    let outletID =
      value.OutletID != undefined ? getDecryptID(value.OutletID) : '0'
    let periodID = value.PeriodID != undefined ? value.PeriodID : '29'
    //console.log("Outlet Name", value);
    const body = {
      PeriodID: periodID,
      OutletID: outletID
    }
    dispatch(loadDashboardSearchData(body))
  }

  return (
    <>
      <div className='ant-col-md-12 ant-col-sm-24 ant-col-xs-24 WelcomeBox'>
        <Card className='gx-card'>
          <Form
            {...formItemLayout}
            form={form}
            name={'SearchForm'}
            className='ant-advanced-search-form product-search-form'
            layout='horizontal'
            onFinish={onFinish}
            initialValues={getReduxDashboardSearchData}
          >
            <>
              <div className='Welcome-box-Content'>
                <div className='Welcome-Text'>
                  <h2 className='heading-fonts-adjust'>
                    <IntlMessages id='dashboard.dashboardreporting.hi' />{' '}
                    {getReduxStoreInfo && getReduxStoreInfo.storeName ? (
                      <>
                        <span className='Welcometo'>
                          {' '}
                          <IntlMessages id='dashbaord.main.title1' />{' '}
                        </span>
                        <span className='StoreName-txt'>
                          {' '}
                          {` ${getReduxStoreInfo.storeName}`}
                        </span>
                      </>
                    ) : (
                      'Welcome'
                    )}
                  </h2>

                  <p className='gx-text-grey'>
                    <IntlMessages id='dashboard.dashboardreporting.whatshappening' />
                  </p>
                </div>

                <div className='Welcome-Filters Filters-Form'>
                  <Form.Item
                    className='ant-form-item-label-custom'
                    name={'OutletID'}
                  >
                    <Select showSearch optionFilterProp='children'>
                      <Select.Option key={'0'} value={'0'}>
                        {'All'}
                      </Select.Option>
                      {getReduxStoreOutlets &&
                        getReduxStoreOutlets.length > 0 &&
                        getReduxStoreOutlets.map((e, key) => {
                          return (
                            <Select.Option key={key} value={e.id}>
                              {e.outlet}
                            </Select.Option>
                          )
                        })}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    className='ant-form-item-label-custom'
                    name={'PeriodID'}
                  >
                    <Radio.Group
                      options={viewByOptions}
                      optionType='button'
                      size='middle
    '
                    />
                  </Form.Item>

                  <Form.Item className='ant-form-item-label-custom'>
                    <Button
                      className='w-100'
                      htmlType='submit'
                      type='primary'
                      size='large'
                    >
                      <IntlMessages id='reporting.productInventorymovements.search' />
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </>
          </Form>
        </Card>
      </div>
    </>
  )
}

export default FilterSection
